<template>
  <!-- <div id="GoTop" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div> -->
  <div class="consult">
    <p class="firstp">
      <img src="../assets/images/email.png" alt="" />
      <b><img style="width: 70px;height: 70px; margin:0 auto;" src="../assets/images/erweima.png" alt=""></b>
    </p>
    <p class="secondp">
      <img src="../assets/images/phone.png" alt="" />
      <b>电话:0571-86998376</b>
    </p>
    <p class="thirdp">
      <img src="../assets/images/time.png" alt="" />
      <b>工作时间:周一至周五<br />早上9:00至晚上18:00</b>
    </p>
    <p class="goTop" @click="GoTop()">
      <span class="glyphicon glyphicon-chevron-up"></span>
    </p>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false,
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
  },
};
</script>
<style scoped>
.goTop {
  flex: 1;
  height: 100px;
  padding:17px 0;
  background-color: blue;
}
.consult {
  height: 200px;
  width: 100px;
  position: fixed;
  bottom: 140px;
  right: 5px;
  z-index: 100;
  display: flex;
  flex-direction: column;
}

.consult p {
  flex: 1;
  width: 60px;
  background-color: white;
  margin: 10px auto;
  text-align: center;
  border: 2px solid transparent;
  border-radius: 10%;
  transition: border-color 2s;
  animation: glowAnimation 5s infinite;
}

.consult p img {
  width: 60%;
  display: block;
  margin: 12px auto;
}

@keyframes glowAnimation {
  0% {
    box-shadow: 0 0 5px rgba(104, 97, 97, 0.8);
  }
  50% {
    box-shadow: 0 0 30px rgba(104, 97, 97, 0.8);
  }
  100% {
    box-shadow: 0 0 5px rgba(104, 97, 97, 0.8);
  }
}

.consult .firstp {
  position: relative;
}

.consult .firstp > b {
  display: none;
  position: absolute;
  bottom: 0;
  right: 110%;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.consult .firstp:hover > b {
  display: block;
  height: 80px;
  text-align: center;
  width: 80px;
  padding: 5px;
  background-color: white;
  border-radius: 3%;
  animation: slideLeft 0.5s forwards;
}

.consult .secondp {
  position: relative;
}

.consult .secondp > b {
  display: none;
  position: absolute;
  bottom: 0;
  right: 110%;
  padding: 5px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.consult .secondp:hover > b {
  display: block;
  height: 80%;
  text-align: center;
  line-height: 40px;
  width: 170px;
  background-color: white;
  font-size: 16px;
  border-radius: 3%;
  animation: slideLeft 0.5s forwards;
}
.consult .thirdp:hover > b {
  display: block;
  background-color: white;
  width: 180px;
  font-size: 15px;
  height: 80%;
  text-align: center;
  border-radius: 3%;
  animation: slideLeft1 0.5s forwards; /* 向左滑出动画效果 */
}
@keyframes slideLeft {
  from {
    transform: translateX(50px);
  }
  to {
    transform: translateX(-10%);
  }
}
@keyframes slideLeft1 {
  from {
    transform: translateX(50px);
  }
  to {
    transform: translateX(-5%);
  }
}
.firstp > b,
.secondp > b,
.thirdp > b {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 5px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: slideRight 0.5s forwards; /* 向右收回动画效果 */
}

@keyframes slideRight {
  from {
    transform: translateX(-50%);
  }
  to {
    transform: translateX(0);
  }
}
.consult .thirdp {
  position: relative;
}

.consult .thirdp > b {
  display: none;
  position: absolute;
  bottom: 0;
  right: 110%;
  padding: 5;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue